/* eslint-disable no-unused-vars */
import pin_code_master from "../assests/images/master/pin-code-master.svg";
import pin_code_mapping from "../assests/images/master/pin-code-mapping.svg";
import packeting_guide from "../assests/images/master/packeting-guide.svg";
import sorting_guide from "../assests/images/master/sorting-guide.svg";
import rate_card from "../assests/images/master/rate-card.svg";
import route from "../assests/images/master/route.svg";
import hub_access from "../assests/images/hub-access.svg";
import tat from "../assests/images/master/tat.svg";
import other_setting from "../assests/images/master/other-setting.svg";
import cp_onboarding from "../assests/images/globalSetting/cp-onboarding.svg";
import vehicle_onboarding from "../assests/images/globalSetting/vehicle-onboarding.svg";
import client_onboarding from "../assests/images/globalSetting/client-onboarding.svg";
import staff_onboarding from "../assests/images/globalSetting/staff-onboarding.svg";
import hub_onboarding from "../assests/images/globalSetting/hub-onboarding.svg";
import lcrInScan from "../assests/images/middleMile/lcr-in-scan.svg";
import lcrGen from "../assests/images/middleMile/lcr-gen.svg";
import bagging from "../assests/images/middleMile/bagging.svg";
import Sorting from "../assests/images/middleMile/sorting.svg";
import AddCategory from "../assests/images/addCategory.svg";
import openBag from "../assests/images/middleMile/open-bag.svg";
import openPackets from "../assests/images/middleMile/open-packet.svg";
import sortToCp from "../assests/images/middleMile/sort-to-cp.svg";
import mm_inscan from "../assests/images/SVG/mm-in-scan.svg";
import report_vehicle from "../assests/images/SVG/vehicle-utilize.svg";
import packeting from "../assests/images/SVG/packeting.svg";
import my_order from "../assests/images/my-order.svg";
import product_request from "../assests/images/product-request.svg";
import orderRequest from "../assests/images/OrderRequest.svg";
import addProduct from "../assests/images/addProduct.svg";
import createDelivery from "../assests/images/SVG/createDelivery.svg";
import generateDRS from "../assests/images/SVG/generateDRS.svg";
import constants from "../constants/constants";
import checkin_checkout from "../assests/images/middleMile/checkin.svg";
import expection_report from "../assests/images/middleMile/expection-report.svg";
import vehicle_master from "../assests/images/SVG/vehicle-master.svg";

import cp_Approval from "../assests/images/SVG/cp_approval.svg";
import Cp_lead from "../assests/images/SVG/cp_lead-gen.svg";
import client_approval from "../assests/images/SVG/client_approval.svg";
import client_lead from "../assests/images/SVG/client_lead_gen.svg";
import branch_approval from "../assests/images/SVG/branch_approval.svg";
import hubops_config from "../assests/images/hubops-configure.svg";

import misrouted_shipment from "../assests/images/misrouted-shipment.svg";
import billing_configuration from "../assests/images/master/billing_configuration.svg";
import create_trip from "../assests/images/middleMile/create-trip.svg";
import LCRThrshold from "../assests/images/LCRThrshold.svg";
import report from "../assests/images/SVG/report-img.svg";
import Out_scan_setting_icon from "../assests/images/master/Out-scan-setting-icon.svg";
import DrsIcon from "../assests/images/master/DrsIcon.svg";
import booking_vs_audited from "../assests/images/reportSvg/BookingVsAudited.svg";
import booking_status from "../assests/images/reportSvg/BookingVsStatus.png";
import booking_inscan_outscan from "../assests/images/reportSvg/bookingVsInscanOutscanReport.svg";
import hub_audit_entry from "../assests/images/reportSvg/hubAuditEntryReport.svg";
import incoming_bag_report from "../assests/images/reportSvg/incomingBags.svg";
import cashIcon from "../assests/images/cashIcon.svg";
import accountBookingIcon from "../assests/images/AccountBookingsvg.svg";
import incoming_shipment from "../assests/images/reportSvg/incomingShipment.svg";
import mcn_shipment_list from "../assests/images/reportSvg/mcnShipmentList.svg";
import outgoing_shipment from "../assests/images/reportSvg/outscanShipment.svg";
import hub_inbound from "../assests/images/SVG/hub-inbound.svg";
import incoming_lcr from "../assests/images/reportSvg/incomingLcrBag.svg";
import outscan_lcr from "../assests/images/reportSvg/outscanLcrShipment.svg";
import delivery_mis from "../assests/images/reportSvg/deliveryMIS.svg";
import inscanVsOutscan from "../assests/images/reportSvg/inscanVsOutscan.svg";
import transit_lcr from "../assests/images/LCRIcons/transit_lcr.svg";
import fastrack_report from "../assests/images/reportSvg/fastTrack.png";
import middle_mile_tat from "../assests/images/master/middle-mile-tat.svg";
const { ROLES } = constants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  ROLE_HOMARKETING,
  ROLE_ZONALHEAD,
  ROLE_ZONALOPERATOR,
  ROLE_RM,
  ROLE_FUNCTIONALHEAD,
  ROLE_MD,
  ROLE_CENTRALOPERATOR,
  ROLE_BOOKINGAUDITONLY,
  ROLE_HUBOPERATOR,
  DEVELOPER,
  CUSTOMER_DELIGHT_EXECUTIVE,
  ROLE_CSO,
  ROLE_HOCRM
} = ROLES;

export const parentMaster = [
  {
    mainRoute: "/masters",
    masterProperty: {
      headingTitle: "Master Settings",
      searchPlaceholder: "Search master setting",
      searchPresent: true,
    },
    masterData: [
      // {
      //   id: 1,
      //   imgSrc: pin_code_master,
      //   title: "PIN code master",
      //   route: "/pincode-master",
      //   disable: false,
      //   childPresent: false,
      //   role: [HO_ADMIN, DEVELOPER],
      // },
      {
        id: 19,
        imgSrc: pin_code_master,
        title: "Pincode Management",
        route: "/pincode-management",
        disable: false,
        childPresent: false,
        role: [
          HO_ADMIN,
          DEVELOPER,
          ROLE_FUNCTIONALHEAD,
          HUB_ADMIN,
          ROLE_ZONALHEAD,
          ROLE_ZONALOPERATOR,
          ROLE_RM,
          ROLE_MD,
          ROLE_CENTRALOPERATOR,
          ROLE_BOOKINGAUDITONLY,
          ROLE_HUBOPERATOR,
          CP_ADMIN,
          ROLE_HOMARKETING,
          ROLE_CSO,
          ROLE_HOCRM,
        ],
      },
      {
        id: 20,
        imgSrc: hub_inbound,
        title: "Pincode Map",
        route: "/pincode-map",
        disable: false,
        childPresent: false,
        role: [
          HO_ADMIN,
          DEVELOPER,
          ROLE_FUNCTIONALHEAD,
          HUB_ADMIN,
          ROLE_ZONALHEAD,
          ROLE_ZONALOPERATOR,
          ROLE_RM,
          ROLE_MD,
          ROLE_CENTRALOPERATOR,
          ROLE_BOOKINGAUDITONLY,
          ROLE_HUBOPERATOR,
          CP_ADMIN,
          ROLE_HOMARKETING,
          ROLE_CSO,
          ROLE_HOCRM,
        ],
      },
      // {
      //   id: 2,
      //   imgSrc: pin_code_mapping,
      //   title: "PIN code mapping",
      //   route: "/pin-code-mapping",
      //   disable: false,
      //   childPresent: false,
      //   role: [HO_ADMIN, DEVELOPER],
      // },
      {
        id: 3,
        imgSrc: packeting_guide,
        title: "packeting guide",
        route: "/packeting-guide",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER],
      },
      {
        id: 4,
        imgSrc: sorting_guide,
        title: "sorting guide",
        route: "/sorting-guide",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER],
      },
      // {
      //   id: 5,
      //   imgSrc: rate_card,
      //   title: "rate card master",
      //   disable: false,
      //   childPresent: true,
      //   role: [HO_ADMIN, DEVELOPER],
      // },
      {
        id: 6,
        imgSrc: route,
        title: "route master",
        route: "/route-configuration",
        disable: false,
        childPresent: true,
        role: [HO_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_HOCRM],
      },
      {
        id: 7,
        imgSrc: tat,
        title: "TAT master",
        disable: false,
        childPresent: true,
        role: [HO_ADMIN, DEVELOPER],
      },
      // {
      //   id: 8,
      //   imgSrc: other_setting,
      //   title: "others setting",
      //   route: "",
      //   disable: true,
      //   childPresent: false,
      //   role: [HO_ADMIN, DEVELOPER],
      // },
      // {
      //   id: 9,
      //   imgSrc: billing_configuration,
      //   title: "Billing Configuration",
      //   route: "",
      //   disable: false,
      //   childPresent: true,
      //   role: [HO_ADMIN, DEVELOPER],
      // },
      {
        id: 10,
        imgSrc: hubops_config,
        title: "HubOps Configurations",
        route: "",
        disable: false,
        childPresent: true,
        role: [HO_ADMIN, DEVELOPER],
      },
      {
        id: 11,
        imgSrc: route,
        title: "vehicle route master",
        route: "/hub-route-configuration",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, DEVELOPER],
      },
      // {
      //   id: 11,
      //   imgSrc: route,
      //   title: "HubOps Configurations",
      //   route: "/hub-ops-configuration",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN],
      // },
      // {
      //   id: 12,
      //   imgSrc: pin_code_master,
      //   title: "HUB Pin code mapping",
      //   route: "/hub-pincode-mapping",
      //   disable: false,
      //   childPresent: false,
      //   role: [HO_ADMIN, DEVELOPER],
      // },
      {
        id: 13,
        imgSrc: pin_code_master,
        title: "HUB CP Linking",
        route: "/hub-cp-linking",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER],
      },
      {
        id: 14,
        imgSrc: Out_scan_setting_icon,
        title: "Out Scan CP Master",
        route: "/hub-cp-master",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, HUB_ADMIN, DEVELOPER],
      },
      {
        id: 15,
        imgSrc: DrsIcon,
        title: "Sevasetu DRS Lock",
        route: "/DRS-Master",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, DEVELOPER],
      },
      {
        id: 16,
        imgSrc: pin_code_mapping,
        title: "VayuQuick PIN Code Mapping",
        route: "/vayuquick-pincode-mapping",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_HOCRM],
      },
      {

        id: 17,
        imgSrc: middle_mile_tat,
        title: "Shipment Routes",
        route: "/route-configuration?type=SURFACE",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, ROLE_MD, HO_ADMIN, ROLE_RM, ROLE_ZONALOPERATOR, ROLE_ZONALHEAD],
      },
      {
        id: 18,
        imgSrc: hub_access,
        title: "Hub Access",
        route: "/hub-access",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER],
      }
    ],
  },
  {
    mainRoute: "/onboarding-settings",
    masterProperty: {
      headingTitle: "Onboard Settings",
      searchPlaceholder: "Search onboard setting",
      searchPresent: true,
    },
    masterData: [
      {
        id: 1,
        imgSrc: staff_onboarding,
        title: "Staff Onboarding",
        route: "/staff-onboarding",
        disable: false,
        childPresent: false,
        role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, DEVELOPER],
      },
      {
        id: 2,
        imgSrc: cp_onboarding,
        title: "CP Onboarding",
        route: "/cp-onboarding",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER],
      },
      {
        id: 3,
        imgSrc: vehicle_onboarding,
        title: "Vehicle Onboarding",
        route: "/vehicle-onboard",
        disable: false,
        childPresent: false,
        role: [CP_ADMIN, HUB_ADMIN, DEVELOPER],
      },
      {
        id: 4,
        imgSrc: hub_onboarding,
        title: "Hub Onboarding",
        route: "/hub-onboarding",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER],
      },
      // {
      //   id: 6,
      //   imgSrc: client_approval,
      //   title: "Client Approval",
      //   route: "/client-lead-generation-list",
      //   disable: true,
      //   childPresent: false,
      //   role: [HO_ADMIN],
      // },
      // {
      //   id: 6,
      //   imgSrc: cp_Approval,
      //   title: "Approval",
      //   route: "/cp-approval-lead-list",
      //   disable: false,
      //   childPresent: false,
      //   role: [HO_ADMIN],
      // },
      {
        id: 6,
        imgSrc: cp_Approval,
        title: "Approval",
        route: "/all-approvals",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER],
      },
      {
        id: 7,
        imgSrc: vehicle_onboarding,
        title: "DP Management",
        route: "/delivery-partner-list",
        disable: false,
        childPresent: false,
        role: [HO_ADMIN, DEVELOPER],
      },
      // {
      //   id: 6,
      //   imgSrc: branch_approval,
      //   title: "Branch Approval",
      //   route: "/client-list",
      //   disable: true,
      //   childPresent: false,
      //   role: [HO_ADMIN],
      // },
      // {
      //   id: 7,
      //   imgSrc: client_onboarding,
      //   title: "Lead Approval",
      //   route: "/cp-approval-lead-list",
      //   disable: false,
      //   childPresent: false,
      //   role: [HO_ADMIN],
      // },
      {
        id: 8,
        imgSrc: vehicle_master,
        title: "Vehicle Master",
        route: "/vehicle-master",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, DEVELOPER],
      },
      // {
      //   id: 8,
      //   imgSrc: Cp_lead,
      //   title: "CP Lead Generation",
      //   route: "/cp-lead-generation-list",
      //   disable: false,
      //   childPresent: false,
      //   role: [ROLE_HOMARKETING, DEVELOPER],
      // },
      // {
      //   id: 9,
      //   imgSrc: client_lead,
      //   title: "DP Lead Generation",
      //   route: "/dp-lead-generation-list",
      //   role: [ROLE_HOMARKETING, DEVELOPER],
      // },
      // {
      //   id: 10,
      //   imgSrc: client_lead,
      //   title: "Client Lead Generation",
      //   route: "/client-lead-generation-list",
      //   role: [CP_ADMIN],
      // },
      // {
      //   id: 10,
      //   imgSrc: client_lead,
      //   title: "Client Lead Generation",
      //   route: "/client-lead-generation-list",
      //   role: [CP_ADMIN],
      // },
    ],
  },
  {
    mainRoute: "/approvals-settings",
    masterProperty: {
      headingTitle: "Approvals",
      searchPlaceholder: "Search onboard setting",
      searchPresent: false,
    },
    masterData: [
      {
        id: 1,
        imgSrc: cp_Approval,
        title: "CP",
        route: "/approvals-cp",
        disable: false,
        childPresent: false,
        role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, DEVELOPER],
      },

    ],
  },
  {
    mainRoute: "/middle-mile",
    masterProperty: {
      headingTitle: "Hub Outbound",
      searchPlaceholder: "Search hub outbound",
      searchPresent: true,
    },
    masterData: [
      {
        id: 1,
        imgSrc: mm_inscan,
        title: "In Scan",
        route: "/consolidated-manifest",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      },
      {
        id: 2,
        imgSrc: Sorting,
        title: "Sort Shipment",
        route: "/sort-shipment",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      },
      // {
      //   id: 3,
      //   imgSrc: packeting,
      //   title: "Packeting",
      //   route: "/packeting",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN],
      // },
      {
        id: 4,
        imgSrc: bagging,
        title: "Bagging",
        route: "/shipment-bagging",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      },
      // {
      //   id: 5,
      //   imgSrc: lcrGen,
      //   title: "LCR Generation",
      //   route: "/create-or-update-trip",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      // },
      {
        id: 6,
        imgSrc: create_trip,
        title: "LCR View",
        route: "/new-lcr-generation",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      },
      // {
      //   id: 6,
      //   imgSrc: misrouted_shipment,
      //   title: "Exceptions",
      //   route: "/excess-misrouted",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN],
      // },
    ],
  },
  {
    mainRoute: "/hub-in-scan",
    masterProperty: {
      headingTitle: "Hub Inbound",
      searchPlaceholder: "Search hub inbound",
      searchPresent: true,
    },
    masterData: [
      {
        id: 1,
        imgSrc: lcrInScan,
        title: "LCR IN-Scan",
        route: "/lcr-scan-list",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      },
      // {
      //   id: 2,
      //   imgSrc: openBag,
      //   title: "Open Bags",
      //   route: "/lcr-scanned-bags",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN],
      // },
      // {
      //   id: 3,
      //   imgSrc: openPackets,
      //   title: "Open Packets",
      //   route: "/scan-packets",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN],
      // },

      // {
      //   id: 4,
      //   imgSrc: sortToCp,
      //   title: "Sort to Last Mile",
      //   route: "/sort-to-cp",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      // },
      // {
      //   id: 5,
      //   imgSrc: generateDRS,
      //   title: "Generate Manifest",
      //   route: "/generateManifest",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN],
      // },
      {
        id: 5,
        imgSrc: generateDRS,
        title: "Manifest",
        route: "/generateManifest",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      },

    ],
  },
  {
    mainRoute: "/configuration-guide",
    masterProperty: {
      headingTitle: "Configuration",
      searchPlaceholder: "",
      searchPresent: false,
    },
    masterData: [
      {
        id: 1,
        imgSrc: Sorting,
        title: "Sorting Guide",
        route: "/sorting-guide",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, DEVELOPER],
      },
    ],
  },
  {
    mainRoute: "/last-mile-operations",
    masterProperty: {
      headingTitle: "Last Mile Operations",
      searchPlaceholder: "",
      searchPresent: false,
    },
    masterData: [
      {
        id: 1,
        imgSrc: mm_inscan,
        title: "In Scan Shipments",
        route: "/in-scan-cp",
        disable: false,
        childPresent: false,
        role: [CP_ADMIN],
      },

      {
        id: 2,
        imgSrc: generateDRS,
        title: "Generate DRS",
        route: "/generate-drs",
        disable: false,
        childPresent: false,
        role: [CP_ADMIN],
      },
      {
        id: 3,
        imgSrc: mm_inscan,
        title: "DRS Eligibility",
        route: "/pending-drs",
        disable: false,
        childPresent: false,
        role: [CP_ADMIN],
      },
      {
        id: 4,
        imgSrc: createDelivery,
        title: "Create Delivery Area",
        route: "/create-virtual-area",
        disable: false,
        childPresent: false,
        role: [CP_ADMIN],
      },
    ],
  },
  {
    mainRoute: "/reports",
    masterProperty: {
      headingTitle: "Reports",
      searchPlaceholder: "",
      searchPresent: false,
    },
    masterData: [
      // {
      //   id: 13,
      //   imgSrc: accountBookingIcon,
      //   title: "Account Bookings",
      //   additionalClass: "",
      //   route: "/account-bookings",
      //   role: [ROLE_MD],
      // },
      // {
      //   id: 14,
      //   imgSrc: cashIcon,
      //   title: "Cash Bookings",
      //   additionalClass: "",
      //   route: "/cash-booking",
      //   role: [ROLE_MD],
      // },
      // {
      //   id: 15,
      //   imgSrc: hub_inbound,
      //   title: "HubOps Dashboard",
      //   additionalClass: "",
      //   route: "/hub-ops-dashboard",
      //   role: [ROLE_MD],
      // },
      // {
      //   id: 16,
      //   imgSrc: report,
      //   title: "Delivery Dashboard",
      //   additionalClass: "",
      //   route: "/delivery-dashboard",
      //   role: [ROLE_MD],
      // },
      // {
      //   id: 25,
      //   imgSrc: report,
      //   title: "Booking Volume Reports",
      //   additionalClass: "",
      //   route: "/booking-volume-reports",
      //   role: [ROLE_MD],
      // },

      // {
      //   id: 27,
      //   imgSrc: report,
      //   title: "TAT Analysis Reports",
      //   additionalClass: "",
      //   route: "/tat-analysis-reports",
      //   role: [ROLE_MD],
      // },
      // {
      //   id: 28,
      //   imgSrc: report,
      //   title: "Pin Code Active/Inactive Timeline",
      //   additionalClass: "",
      //   route: "/pin-code-active-inactive-timeline-reports",
      //   role: [ROLE_MD],
      // },

      {
        id: 17,
        imgSrc: incoming_shipment,
        title: "Incoming Shipment",
        isVerified: true,
        additionalClass: "",
        route: "/incoming-shipment-report",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 18,
        imgSrc: outgoing_shipment,
        title: "Outgoing Shipment",
        isVerified: true,
        additionalClass: "",
        route: "/outgoing-shipment",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 19,
        imgSrc: incoming_lcr,
        title: "Incoming LCR ",
        additionalClass: "",
        route: "/incoming-lcr",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      },

      {
        id: 20,
        imgSrc: outscan_lcr,
        title: "Outgoing LCR",
        additionalClass: "",
        route: "/outgoing-lcr",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
      },
      {
        id: 30,
        imgSrc: transit_lcr,
        title: "LCR Tally",
        isVerified: true,
        additionalClass: "",
        route: "/transit-lcr",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      {
        id: 31,
        imgSrc: createDelivery,
        title: "Delivery Status",
        isVerified: true,
        additionalClass: "",
        route: "/delivery-status",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      {
        id: 32,
        imgSrc: booking_inscan_outscan,
        title: "Hub-Outscan Vs CP Inscan Report",
        isVerified: true,
        additionalClass: "",
        route: "/outscan-cpinscan",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      {
        id: 70,
        imgSrc: booking_inscan_outscan,
        title: "Hub-Outscan Vs CP Inscan Report A3",
        additionalClass: "",
        route: "/hub-outscan-vs-cp-inscan-report-a3",
        role: [ROLE_CENTRALOPERATOR, DEVELOPER]
      },
      {
        id: 35,
        imgSrc: booking_inscan_outscan,
        title: "CP Outscan vs Hub Inscan Report",
        isVerified: true,
        additionalClass: "",
        route: "/cp-outscan-vs-hub-inscan",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      {
        id: 36,
        imgSrc: booking_inscan_outscan,
        title: "Eway Bill Report",
        additionalClass: "",
        route: "/eway-bill-report",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      {
        id: 37,
        imgSrc: booking_inscan_outscan,
        title: "Inscan Shipments Report",
        additionalClass: "",
        route: "/inscan-report",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      {
        id: 38,
        imgSrc: booking_inscan_outscan,
        title: "MCN Report",
        additionalClass: "",
        route: "/mcn-report",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      // {
      //   id: 40,
      //   imgSrc: booking_inscan_outscan,
      //   title: "Force Shipment Scan Report",
      //   additionalClass: "",
      //   route: "/force-shipment-report",
      //   role: [ROLE_MD,HUB_ADMIN,ROLE_ZONALHEAD,ROLE_ZONALOPERATOR,ROLE_RM,ROLE_FUNCTIONALHEAD,HO_ADMIN,ROLE_CENTRALOPERATOR,ROLE_HUBOPERATOR]  
      // },
      {
        id: 39,
        imgSrc: booking_inscan_outscan,
        title: "Force Bag Report",
        additionalClass: "",
        route: "/force-bag-report",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
      },

      {
        id: 41,
        imgSrc: booking_inscan_outscan,
        title: "Force Bag Attempt Shipment",
        additionalClass: "",
        route: "/force-bag-attempt-shipment",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, ROLE_HOCRM]
      },
      {
        id: 42,
        imgSrc: booking_inscan_outscan,
        title: "Wrong Sorting Report",
        additionalClass: "",
        route: "/wrong-sorting-report",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      {
        id: 33,
        imgSrc: hub_audit_entry,
        title: "Hub Audit Report",
        additionalClass: "",
        route: "/hub-audit",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM]
      },
      {
        id: 21,
        imgSrc: booking_vs_audited,
        title: "Booked Vs Audited",
        isVerified: true,
        additionalClass: "",
        route: "/booked-vs-audited-report",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, ROLE_BOOKINGAUDITONLY, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 22,
        imgSrc: booking_inscan_outscan,
        title: "Inscan Vs Audited",
        additionalClass: "",
        isVerified: true,
        route: "/inscan-vs-audit-report",
        role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 23,
        imgSrc: delivery_mis,
        title: "Delivery MIS",
        additionalClass: "",
        route: "/delivery-mis-report",
        role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 1,
        imgSrc: report_vehicle,
        title: "Vehicle Utilization",
        route: "/vehicle-trip-list",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, DEVELOPER],
      },
      {
        id: 2,
        imgSrc: checkin_checkout,
        title: "Vehicle Check-In Check-Out",
        route: "/vehicle-checkin-checkout",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, DEVELOPER],
      },
      {
        id: 3,
        imgSrc: expection_report,
        title: "Exception Report",
        route: "/exception-report",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, DEVELOPER],
      },
      {
        id: 6,
        imgSrc: booking_status,
        title: "Booking Data vs Status Report",
        route: "/booking-status-report",
        disable: false,
        isVerified: true,
        childPresent: false,
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 8,
        imgSrc: hub_audit_entry,
        title: "Hub Audit Entry Report",
        isVerified: true,
        route: "/hub-audit-entry-report",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 9,
        imgSrc: incoming_bag_report,
        title: "Incoming Bag Report",
        isVerified: true,
        route: "/incoming-bag-report",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 10,
        imgSrc: incoming_bag_report,
        title: "Outgoing Bag Report",
        isVerified: true,
        route: "/outgoing-bag-report",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 11,
        imgSrc: fastrack_report,
        title: "Fast Track / Value Plus Report",
        route: "/fast-track-report",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM],
      },
      // {
      //   id: 12,
      //   imgSrc: report,
      //   title: "Control Tower Hub Report",
      //   route: "/control-tower-hub-report",
      //   disable: false,
      //   childPresent: false,
      //   role: [HUB_ADMIN],
      // },
      //MD Reports



      {
        id: 24,
        imgSrc: inscanVsOutscan,
        title: "Booking vs First Inscan",
        additionalClass: "",
        isVerified: true,
        route: "/booking-inscan-outscan-report",
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },

      {
        id: 26,
        imgSrc: report,
        title: "VayuQuick/PRO",
        additionalClass: "",
        route: "/vayuquick-pro",
        role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM],
      },

      {
        id: 29,
        imgSrc: report,
        title: "Pincode Discrepancies Report",
        additionalClass: "",
        route: "/pincode-discrepancies-report",
        role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      // {
      //   id: 34,
      //   imgSrc: report,
      //   title: "Excess In-Scan Report",
      //   additionalClass: "",
      //   route: "/excess-in-scan-report",
      //   role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, DEVELOPER],
      // },
      {
        id: 43,
        imgSrc: report,
        title: "Booking vs Delivery Report",
        additionalClass: "",
        isVerified: true,
        route: "/booking-vs-delivery-report",
        role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 44,
        imgSrc: booking_inscan_outscan,
        title: "Shipments Inscan vs Outscan Report",
        isVerified: true,
        additionalClass: "",
        route: "/shipments-inscan-vs-outscan-report",
        role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 45,
        imgSrc: booking_inscan_outscan,
        title: "Excess Inscan Enhanced Report",
        isVerified: true,
        additionalClass: "",
        route: "/excess-in-scan-enhanced-report",
        role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 64,
        imgSrc: report,
        title: "Control Tower Reports",
        additionalClass: "",
        route: "/control-tower-reports",
        role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_CSO, ROLE_HOCRM],
      },
      {
        id: 61,
        imgSrc: report,
        title: "ODA Delivery Adoption",
        additionalClass: "",
        route: "/oda-drs-status-update-adoption",
        role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 62,
        imgSrc: report,
        title: "Finalized Bags Pending Outscan Report",
        additionalClass: "",
        route: "/finalized-bags-pending-outscan-report",
        role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 63,
        imgSrc: report,
        title: "Director Dashboard New",
        additionalClass: "",
        route: "/director-dashboardNew",
        role: [ROLE_MD],
      },
      {
        id: 65,
        imgSrc: report,
        title: "Shipment Inscanned v/s Weight Audited Adherence",
        isVerified: true,
        additionalClass: "",
        route: "/shipment-inscanned-vs-weight-audited-adherence",
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 66,
        imgSrc: report,
        title: "Booking Report",
        additionalClass: "",
        route: "/booking-report",
        role: [HO_ADMIN, ROLE_FUNCTIONALHEAD, ROLE_RM, ROLE_CENTRALOPERATOR, ROLE_HOCRM],
      },
      {
        id: 67,
        imgSrc: report,
        title: "RTO Shipment with Reason Report",
        additionalClass: "",
        route: "/rto-with-reason-report",
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 68,
        imgSrc: report,
        title: "Non-FT Premium Bookings Report",
        additionalClass: "",
        route: "/non-ft-premium-bookings-report",
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_CSO, ROLE_HOCRM],
      },
      {
        id: 69,
        imgSrc: report,
        title: "Inscanned Bags Report",
        additionalClass: "",
        route: "/inscanned-bags-report",
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM],
      },
    ],
  },
  //mcn
  {
    mainRoute: "/mcn",
    masterProperty: {
      headingTitle: "MCN ",
      searchPlaceholder: "Search MCN setting",
      searchPresent: true,
    },
    masterData: [
      {
        id: 1,
        imgSrc: mm_inscan,
        title: "MCN Inbound",
        route: "/mcn-in-bound",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 2,
        imgSrc: mm_inscan,
        title: "MCN Outbound",
        route: "/mcn-out-bound",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },
      {
        id: 3,
        imgSrc: mm_inscan,
        title: "Smile Label Generation",
        route: "/smile-label-generation",
        disable: false,
        childPresent: false,
        role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM],
      },

    ],
  },
];
